import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=13a9f7a0&"
import script from "./TermOfService.vue?vue&type=script&lang=js&"
export * from "./TermOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports